
const projects = [
  {
    title: 'Chat Application',
    image: 'https://github.com/SIDTK365/Chat-Application/blob/master/client/public/Chat-App-Img.png?raw=true',
    description: 'Implemented a real-time chat-room application with NodeJS, ReactJS, Socket.io and TailwindCSS. The page automatically scrolls down upon receiving a new message and is built on completely responsive web design.',
    tools: ['NodeJS', 'ReactJS', 'Socket.io', 'TailwindCSS'],
    github: 'https://github.com/SIDTK365/Chat-Application',
    link: 'https://chat-application-final.herokuapp.com/',
  },
  {
    title: 'Reddit Post Scraper',
    image: 'https://github.com/SIDTK365/Randomz/blob/master/public/UpdatedRedditScraper1.png?raw=true',
    description: 'Built a fully responsive website that displays Memes or Posts from various subreddits.',
    tools: ['ReactJS', 'TailwindCSS', 'Axios', 'D3vD’s Meme_Api'],
    github: 'https://github.com/SIDTK365/Randomz',
    link: 'https://reddit-randomz.netlify.app/',
  },
  {
    title: 'Crime Reporting Portal',
    image: 'https://github.com/abhinav0532/Crime-Reporting-Portal/blob/master/Pictures/1.png?raw=true',
    description: 'A basic crime reporting portal built with MongoDB, Express, NodeJS & OAuth 2.0 Authentication service.',
    tools: ['MongoDB', 'Express', 'NodeJS', 'EJS', 'OAuth 2.0'],
    github: 'https://github.com/abhinav0532/Crime-Reporting-Portal',
    link: 'https://crime-reporting-portal.herokuapp.com/',
  },
  {
    title: 'Online JavaScript Code Editor',
    image: 'https://github.com/shubh007-star/JS-Editor/blob/main/Pictures/1.png?raw=true',
    description: 'An in-browser JavaScript CodeEditor built with CodeMirror Library with features like 50+ themes, Autocompletion & Sublime Text Key bindings.',
    tools: ['HTML', 'CSS', 'JavaScript', 'CodeMirror', 'Bootstrap'],
    github: 'https://github.com/shubh007-star/JS-Editor',
    link: 'https://shubh007-star.github.io/JS-Editor/',
  },
  // {
  //   title: 'Recipe Finder',
  //   image: './images/recipeApp-mockup',
  //   description: 'Browse recipes from a variety of sources. Users can save recipes to view them later. API from themealdb.com.',
  //   tools: ['Javascript', 'API'],
  //   github: 'https://github.com/Deelip7/RecipesFinder',
  //   link: 'https://practical-archimedes-a61091.netlify.app/',
  // },
];

export default projects;
